var _style, _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTennis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE8F61;}\n\t.st1{fill:#A8B1BC;}\n\t.st2{fill:#CBCFD7;}\n\t.st3{fill:#E5E7EC;}\n\t.st4{fill:#646D78;}\n\t.st5{fill:#EFC05D;}\n\t.st6{fill:#F6D99E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,182.8c42.7,0,77.3-34.3,77.3-76.6c0-42.3-34.6-76.6-77.3-76.6s-77.3,34.3-77.3,76.6 C29.2,148.5,63.8,182.8,106.5,182.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.6,111.4l-27.9-15.8c-0.9-0.5-1.2-1.6-0.7-2.4c0.5-0.9,1.6-1.2,2.4-0.7l27.9,15.8c0.9,0.5,1.2,1.6,0.7,2.4 C131.5,111.6,130.4,111.9,129.6,111.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.9,106.8l-33.5-19c-0.9-0.5-1.2-1.6-0.7-2.4s1.6-1.2,2.4-0.7l33.5,19c0.9,0.5,1.2,1.6,0.7,2.4 C137.8,107,136.7,107.3,135.9,106.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.7,100.8l-34.1-19.4c-0.9-0.5-1.2-1.6-0.7-2.4c0.5-0.9,1.6-1.2,2.4-0.7l34.1,19.4c0.9,0.5,1.2,1.6,0.7,2.4 C141.6,101,140.6,101.3,139.7,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M143.2,94.6l-34.1-19.4c-0.9-0.5-1.2-1.6-0.7-2.4c0.5-0.9,1.6-1.2,2.4-0.7L145,91.5c0.9,0.5,1.2,1.6,0.7,2.4 S144.1,95.1,143.2,94.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.4,88.2l-33.5-19c-0.9-0.5-1.2-1.6-0.7-2.4c0.5-0.9,1.6-1.2,2.4-0.7l33.5,19c0.9,0.5,1.2,1.6,0.7,2.4 S147.3,88.7,146.4,88.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.2,80.4l-27.9-15.8c-0.9-0.5-1.2-1.6-0.7-2.4c0.5-0.9,1.6-1.2,2.4-0.7l27.9,15.8c0.9,0.5,1.2,1.6,0.7,2.4 C149.1,80.6,148,80.9,147.2,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.6,102.9c-0.9-0.5-1.2-1.6-0.7-2.4l22.9-40.3c0.5-0.9,1.6-1.2,2.4-0.7c0.9,0.5,1.2,1.6,0.7,2.4l-22.9,40.3 C105.6,103.1,104.5,103.4,103.6,102.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.3,109.2c-0.9-0.5-1.2-1.6-0.7-2.4l26.1-45.9c0.5-0.9,1.6-1.2,2.4-0.7s1.2,1.6,0.7,2.4l-26.1,45.9 C110.2,109.4,109.1,109.7,108.3,109.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M114.5,112.7c-0.9-0.5-1.2-1.6-0.7-2.4l26.1-45.9c0.5-0.9,1.6-1.2,2.4-0.7s1.2,1.6,0.7,2.4L116.9,112 C116.4,112.9,115.3,113.2,114.5,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.3,113.4c-0.9-0.5-1.2-1.6-0.7-2.4l22.9-40.3c0.5-0.9,1.6-1.2,2.4-0.7c0.9,0.5,1.2,1.6,0.7,2.4l-22.9,40.3 C124.2,113.6,123.1,113.9,122.3,113.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.2,83.8c-0.6,1.1-1.1,2.2-1.5,3.3c-0.8,2.6-1.1,5.2-0.7,7.8l0,0c0.2,1.7,0.6,3.3,1.3,4.8l0,0 c1,2.4,2.6,4.5,4.6,6.3c0.9,0.8,1.9,1.5,2.9,2.1c1.1,0.6,2.2,1.1,3.3,1.5c2.6,0.8,5.2,1.1,7.8,0.7l0,0c1.7-0.2,3.3-0.6,4.8-1.3l0,0 c2.4-1,4.5-2.6,6.3-4.6c0.8-0.9,1.5-1.9,2.1-2.9l1.8-3.1l3.5-6.2l1.8-3.1c0.6-1.1,1.1-2.2,1.5-3.3c0.8-2.6,1.1-5.2,0.7-7.8l0,0 c-0.2-1.7-0.6-3.3-1.3-4.8l0,0c-1-2.4-2.6-4.5-4.6-6.3c-0.9-0.8-1.9-1.5-2.9-2.1c-1.1-0.6-2.2-1.1-3.3-1.5 c-2.6-0.8-5.2-1.1-7.8-0.7c-1.7,0.2-3.3,0.6-4.8,1.3l0,0c-2.4,1-4.5,2.6-6.3,4.6c-0.8,0.9-1.5,1.9-2.1,2.9l-1.8,3.1l-3.5,6.2 L106.2,83.8z M110.3,112.8c-3.9-2.2-6.9-5.4-8.9-9c-3.7-6.8-4-15.3,0.1-22.6l7-12.4c6.3-11.1,20.5-15,31.6-8.7s15,20.5,8.7,31.6 l-7,12.4c-4.1,7.3-11.7,11.5-19.5,11.7C118.3,115.9,114.1,115,110.3,112.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "106.3,129 91.3,155.3 83.5,150.9 98.5,124.6 100.1,125.5 104.7,128.1  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8,129.6c-0.9-0.5-1.2-1.6-0.7-2.4l0.9-1.5c0.5-0.9,1.6-1.2,2.4-0.7c0.9,0.5,1.2,1.6,0.7,2.4l-0.9,1.5 C105.8,129.8,104.7,130.1,103.8,129.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2,127c-0.9-0.5-1.2-1.6-0.7-2.4l0.9-1.5c0.5-0.9,1.6-1.2,2.4-0.7c0.9,0.5,1.2,1.6,0.7,2.4l-0.9,1.5 C101.1,127.2,100,127.5,99.2,127z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.7,128.1c-0.9-0.5-1.2-1.6-0.7-2.4c3.7-6.5,10.3-10.8,17.7-11.6c0.3,0,0.5,0,0.8-0.1 c1-0.1,1.8,0.7,1.9,1.7c0.1,1-0.7,1.8-1.7,1.9c-0.2,0-0.4,0-0.6,0.1c-6.3,0.7-11.8,4.3-14.9,9.8 C106.7,128.3,105.6,128.6,104.7,128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M100.1,125.5c-0.9-0.5-1.2-1.6-0.7-2.4c3.1-5.5,3.4-12.1,0.7-17.8c-0.1-0.2-0.2-0.4-0.3-0.6 c-0.4-0.9-0.1-2,0.8-2.4c0.9-0.4,2-0.1,2.4,0.8c0.1,0.2,0.2,0.5,0.3,0.7c3.1,6.7,2.8,14.6-0.9,21.1 C102,125.6,100.9,125.9,100.1,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M148.1,93.2c-0.9-0.5-1.2-1.6-0.7-2.4c5.8-10.3,2.2-23.4-8.1-29.2c-10.3-5.8-23.4-2.2-29.2,8.1 c-0.5,0.9-1.6,1.2-2.4,0.7c-0.9-0.5-1.2-1.6-0.7-2.4c6.8-12,22.1-16.2,34-9.4s16.2,22.1,9.4,34C150,93.4,148.9,93.7,148.1,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M109.4,114.4c-12-6.8-16.2-22.1-9.4-34c0.5-0.9,1.6-1.2,2.4-0.7c0.9,0.5,1.2,1.6,0.7,2.4 c-5.8,10.3-2.2,23.4,8.1,29.2s23.4,2.2,29.2-8.1c0.5-0.9,1.6-1.2,2.4-0.7c0.9,0.5,1.2,1.6,0.7,2.4 C136.7,116.9,121.4,121.2,109.4,114.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M100.7,82.8c-0.9-0.5-1.2-1.6-0.7-2.4l7-12.4c0.5-0.9,1.6-1.2,2.4-0.7c0.9,0.5,1.2,1.6,0.7,2.4l-7,12.4 C102.6,82.9,101.6,83.2,100.7,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141,105.6c-0.9-0.5-1.2-1.6-0.7-2.4l7-12.4c0.5-0.9,1.6-1.2,2.4-0.7c0.9,0.5,1.2,1.6,0.7,2.4l-7,12.4 C143,105.8,141.9,106.1,141,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M90.4,156.9l-7.8-4.4c-0.9-0.5-1.2-1.6-0.7-2.4l15-26.4c0.5-0.9,1.6-1.2,2.4-0.7l7.8,4.4 c0.9,0.5,1.2,1.6,0.7,2.4l-15,26.4C92.4,157.1,91.3,157.4,90.4,156.9z M86,150.3l4.7,2.6l13.2-23.3l-4.7-2.6L86,150.3z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M86.5,93.9c2.7,3.5,3.6,7.8,2.9,11.8c-3.8-2.3-8.7-2.2-12.5,0.7c-3.7,2.8-5.1,7.6-3.9,11.8 c-4.1-0.4-7.9-2.4-10.6-5.9c-2.7-3.5-3.6-7.8-2.9-11.8c3.8,2.3,8.7,2.2,12.5-0.7c3.7-2.8,5.1-7.6,3.9-11.8 C79.9,88.4,83.8,90.4,86.5,93.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.9,88c1.2,4.3-0.2,9-3.9,11.8c-3.7,2.8-8.7,3-12.5,0.7c0.6-3.6,2.6-7.1,5.7-9.5C68.4,88.6,72.2,87.7,75.9,88 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M89.4,105.7c-0.6,3.6-2.6,7.1-5.7,9.5c-3.2,2.4-7,3.4-10.7,3c-1.2-4.3,0.2-9,3.9-11.8 C80.6,103.5,85.6,103.4,89.4,105.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennis);
export default __webpack_public_path__ + "static/media/Tennis.42e1b8366221e974f7c86815269b96ec.svg";
export { ForwardRef as ReactComponent };